import { useState, useEffect, useCallback } from "react";
import { api } from "@/lib/api";
import HeroSection from "@/components/home/HeroSection";
import GetInvolvedBand from "@/components/home/GetInvolvedBand";
import ExplainerVideo from "@/components/home/ExplainerVideo";
import MissionFramingBanner from "@/components/home/MissionFramingBanner";
import StatsStrip from "@/components/home/StatsStrip";
import DonationBand from "@/components/home/DonationBand";
import PlatformFeatures from "@/components/home/PlatformFeatures";
import MissionSection from "@/components/home/MissionSection";
import MentalHealthAccountability from "@/components/home/MentalHealthAccountability";
import CommunityGrid from "@/components/home/CommunityGrid";
import LifecycleBand from "@/components/home/LifecycleBand";
import NewsletterSection from "@/components/home/NewsletterSection";

export default function Home() {
  const [stats, setStats] = useState({ scenarios_count: 0, votes_count: 0, incidents_count: 0, subscribers_count: 0 });

  const fetchStats = useCallback(() => {
    api.get("/stats").then(({ data }) => setStats(data)).catch(() => {});
  }, []);

  useEffect(() => {
    fetchStats();
  }, [fetchStats]);

  return (
    <div className="bg-bbap-bg">
      <HeroSection />
      <GetInvolvedBand />
      <ExplainerVideo />
      <MissionFramingBanner />
      <StatsStrip stats={stats} />
      <DonationBand />
      <PlatformFeatures />
      <MissionSection />
      <MentalHealthAccountability />
      <LifecycleBand />
      <CommunityGrid />
      <NewsletterSection />
    </div>
  );
}
